module.exports = __webpack_public_path__ + "img/group-chat.a1fce07b.png";